import {RESTAURANT_SUCCESS} from 'new-constants/api.constants';
import {RestaurantState} from './restaurant.reducer.types';

const initialState: RestaurantState = {
	cache: [],
};

export const restaurantReducer = (previousState = initialState, action): RestaurantState => {
	switch (action && action.type) {
		case RESTAURANT_SUCCESS:
			return {
				...previousState,
				cache: [
					...previousState.cache.filter(restaurant => restaurant.restaurantId !== action.payload.data.restaurantId),
					action.payload.data,
				],
			};
			break;
		default:
			return previousState;
	}
};
